module.exports = __webpack_public_path__ + "0383e9f4d2674166d004fb42ab623e.png";